
sap["ls"]["preload"]["UCF_Container"] = function() {/* global _assert, _trace, DEBUG, INFO */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_XSSEncoder */
/// <reference path="../../core/util/XSSEncoder.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_ResourceUtil */
/// <reference path="../core/ResourceUtil.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>

/**
 * Container
 *
 * <br>
 * <b>Java Control references</b><br>
 * <a href="../javadoc/com/sap/tc/ls/api/controls/LSContainer.html">LSContainer</a>
 *
 * 
 *
 * @version
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Container(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Container["_"]["UCF_Container"]++; }; 

	if (arguments["length"] === 0) return;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Container.js(37): UCF_Container"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Container.js(38): UCF_Container"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Container.js(39): UCF_Container"); };
	//super
	UCF_Control["apply"](this, [oDomRef, oLS]);

	//Blindlayer is an object from LS.oGetBlindLayer(), it is not visual
	this["oBlindLayer"] = null;

	//LockLayer is the visual object with opacity and loading animation that overlays the container
	this["oLockLayer"] = null;

	//TimoutId for dimension update
	this["sTimeOutId"] = "";

	//Defines whether the loading animation is already visible
	//Normally there is a delay of the loading animation of 2 sec
	//Used to decide whether to show the loading animation immediately after an any event occurred or not
	this["bLoadingAnimationVisible"] = false;

	this["oDomRefEnd"] = UCF_DomUtil["$"](this["sId"] + "-TsEnd");

};window["UCF_Container"] = UCF_Container; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Container"); UCF_Container["_"] = {UCF_Container: 0}; }; ;
UCF_Container["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Container.prototype["sClassName"] = "UCF_Container";

/*
 * Destroys the container and the locking image if necessary
 */
UCF_Container["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["destroy"]++; }; 
	var oWindow = this["oLS"]["oBrowserWindow"];

	if (this["sTimeOutId"] != null) UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);

	oWindow["detachEvent"](oWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	this["cleanUpLockedUI"]();

	this["oDomRefEnd"] = null;
	this["sTimeOutId"] = null;
	this["sLockedDesign"] = null;
	this["sLockedMessage"] = null;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["destroy"] = 0; };

/**
 * Initializes the control
 * This method is only called if the container is locked (see Container.renderer)
 */
UCF_Container["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["initialize"]++; }; 
	//	this.oDomRef.style.width = "100%"; // BLI WDAUIUR1-1454

	// Locked is set by the server,
	// so set the locked flag back to false and let the client lock it
	if (this["bLocked"]) {
		this["bLocked"] = false;
		this["setClientProperty"]("Locked", this["bLocked"], true);
		this["lock"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["initialize"] = 0; };

/**
 * Locks the container for further event processing
 * @public
 */
UCF_Container["prototype"]["lock"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["lock"]++; }; 
	if (this["bLocked"]) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Container " + this["sId"] + " locked.", "Container.js(106): lock"); };

	//attach to any and layout change event
	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["attachEvent"](oWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	oWindow["attachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	//set the locked state
	this["bLocked"] = true;
	this["setClientProperty"]("Locked", this["bLocked"], true);

	// activate the local trackswitch, non-accessiblity mode only
	if (!this["oLS"]["oSystem"]["bIs508"]) {
		if (this["oDomRefEnd"]) UCF_DomUtil["setTabIndex"](this["oDomRefEnd"], 0);
	}

	//set the tabindex and focus myself if the currently focused element is contained in me
	UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
	if (UCF_DomUtil["bContains"](this["oDomRef"], UCF_DomUtil["oGetActiveElement"]()))
		this["focus"]();

	//update the ui
	this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["lock"] = 0; };

/**
 * Unlocks the container for further event processing
 * @public
 */
UCF_Container["prototype"]["unlock"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["unlock"]++; }; 

	if (!this["bLocked"]) return;

	if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, "Container " + this["sId"] + " unlocked.", "Container.js(139): unlock"); };

	//detach from any and layout change event
	var oWindow = this["oLS"]["oBrowserWindow"];
	oWindow["detachEvent"](oWindow["E_EVENTS"]["LayoutChange"], this, "onLayoutChange");
	oWindow["detachEvent"](oWindow["E_EVENTS"]["AnyEvent"], this, "onAnyEvent");

	//set the locked state
	this["bLocked"] = false;
	this["setClientProperty"]("Locked", this["bLocked"], true);

	//a loading animation is not visible anymore. if this container is locked again,
	//display the loading animation again with a timeout
	this["bLoadingAnimationVisible"] = false;

	// deactivate the local trackswitch, non-accessiblity mode only
	if (!this["oLS"]["oSystem"]["bIs508"]) {
		if (this["oDomRefEnd"]) UCF_DomUtil["resetTabIndex"](this["oDomRefEnd"]);
	}

	//reset the tab index
	UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
	//set the focus to the next focusable element

	//update the ui
	this["updateLockedUI"]();

	//set the focus to next focusable childs, in 508 mode
	// TODO check if the current Container is focused
	if (this["oLS"]["oSystem"]["bIs508"]) {
		var oNextControl = this["oGetFirstFocusableChildRecursive"](this["oDomRef"]);
		if (oNextControl) {
			oNextControl["moveFocus"]();
			//return true;
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["unlock"] = 0; };

/**
 * Sets the locked design of the container
 * @param {string} sLockedDesign The new locked design (TRANSPARENT,BORDER,LOADING,SEMI,SEMI_BORDER,SEMI_LOADING)
 */
UCF_Container["prototype"]["setLockedDesign"] = function(sLockedDesign) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedDesign"]++; }; 

	this["sLockedDesign"] = sLockedDesign;
	this["setClientProperty"]("LockedDesign", this["sLockedDesign"], true);
	if (this["bLocked"]) this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedDesign"] = 0; };

/**
 * Sets the locked text of the container
 * @param {string} sLockedMessage The new locked text
 */
UCF_Container["prototype"]["setLockedMessage"] = function(sLockedMessage) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedMessage"]++; }; 

	this["sLockedMessage"] = sLockedMessage;
	this["setClientProperty"]("LockedMessage", this["sLockedMessage"], true);
	if (this["bLocked"]) this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["setLockedMessage"] = 0; };

/**
 * Updates the containers locked visualization
 */
UCF_Container["prototype"]["updateLockedUI"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUI"]++; }; 
	if (this["bLocked"]) {

		//get a new blind layer if needed
		if (!this["oBlindLayer"]) {
			this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();

			//set the z index of the blind layer
			this["oBlindLayer"]["oDomRef"]["iZIndex"] = "" + this["iGetParentZIndex"]() + UCF_LS["E_LAYERS"]["BLINDLAYER"] + 1;
		}

		//get a new lock layer if needed
		if (!this["oLockLayer"] && this["sLockedDesign"] !== "TRANSPARENT") {
			this["oLockLayer"] = this["oCreateLockLayer"]();
			UCF_DomUtil["oAddLayeredElement"](this["oLockLayer"]["oDomRef"], null, this["oDomRef"]);
		}

		//update the dimensions of layers after a timeout
		if (this["sTimeOutId"] != null) UCF_JsUtil["clearDelayedCall"](this["sTimeOutId"]);
		this["sTimeOutId"] = UCF_JsUtil["delayedCall"](0, this, "updateLockedUIDimensions");

	} else {
		this["cleanUpLockedUI"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUI"] = 0; };

/**
 * Cleanup the lock UI
 * @private
 */
UCF_Container["prototype"]["cleanUpLockedUI"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["cleanUpLockedUI"]++; }; 
	if (this["oBlindLayer"]) {
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}

	if (this["oLockLayer"]) {
		UCF_DomUtil["removeFromDom"](this["oLockLayer"]["oDomRef"]);
		this["oLockLayer"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["cleanUpLockedUI"] = 0; };

/**
 * Updates the dimensions of the lock layer dimensions
 */
UCF_Container["prototype"]["updateLockedUIDimensions"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUIDimensions"]++; }; 
	if (!this["bLocked"]) return;

	var oRect = null;

	//apply the dimension to the blind layer
	if (this["oBlindLayer"]) {
		oRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"]);
		this["applyRect"](this["oBlindLayer"]["oDomRef"], oRect);
	}

	//apply the dimension to the lock layer
	if (this["oLockLayer"]) {
		oRect = UCF_DomUtil["oGetObjectRect"](this["oDomRef"], this["oDomRef"]);

		this["applyRect"](this["oLockLayer"]["oDomRef"], oRect);
		//set the position of the loading animation to the center
		if (this["oLockLayer"]["oLoadingDomRef"]) {
			if (!this["bLoadingAnimationVisible"]) {
				UCF_JsUtil["delayedCall"](2000, this, "updateLoadingAnimation", [oRect]);
			} else {
				this["updateLoadingAnimation"](oRect);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLockedUIDimensions"] = 0; };

/**
 * Updates the position of the loading animation
 * and makes it visible if it is currently not visible
 */
UCF_Container["prototype"]["updateLoadingAnimation"] = function(oRect) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLoadingAnimation"]++; }; 
	if (this["oLockLayer"] && this["oLockLayer"]["oLoadingDomRef"]) {
		var o = this["oLockLayer"]["oLoadingDomRef"];
		//calculate the position of the loading animation
		var iDivWidth = o["offsetWidth"];
		//the loading animation div should always be 2 px smaller then the LockContainer; smaler 0 is not supported
		if (iDivWidth > oRect["width"]) o["style"]["width"] = (oRect["width"] > 1 ? (oRect["width"] - 2) : 0) + "px";

		/* //center
		var iLeft = Math.round((oRect.width - iDivWidth) / 2),
			iTop  = Math.round((iTotalHeight - iDivHeight) / 2);
			*/
		// D039230 PB113 - Pioneer - Change TopLeft Position in LS for Loading Text of Locked Container
		var iLeft = 0,
			iTop = 0;
		o["style"]["top"] = iTop > 0 ? iTop + "px" : "0px";
		if (window["UCF_System"]["bIsRTL"]) {
			//just apply to the right
			o["style"]["right"] = iLeft > 0 ? iLeft + "px" : "0px";
		} else {
			o["style"]["left"] = iLeft > 0 ? iLeft + "px" : "0px";
		}
		this["oLockLayer"]["oLoadingDomRef"]["style"]["visibility"] = "visible";
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["updateLoadingAnimation"] = 0; };

/**
 * Creates the lock layer of the container
 * with or without a loading animation or border depending on the locked design
 * @private
 */
UCF_Container["prototype"]["oCreateLockLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["oCreateLockLayer"]++; }; 
	var oDomRef = document["createElement"]("CENTER"),
		bLoading = this["sLockedDesign"]["indexOf"]("LOADING") > -1,
		bBorder = this["sLockedDesign"]["indexOf"]("BORDER") > -1,
		bSemi = this["sLockedDesign"]["indexOf"]("SEMI") > -1,
		iZIndex = this["iGetParentZIndex"]() + UCF_LS["E_LAYERS"]["BLINDLAYER"] + 2,
		sLoadingDiv = '',
		oLoadingDomRef = null,
		sText = null,
		sTextLength = null,
		bLockAnim = "<div class=\"lsLockAItem lsLockAItem1Display lsLockAItem1Delay\"></div>" +
		"<div class=\"lsLockAItem lsLockAItem2Display lsLockAItem2Delay\"></div>" +
		"<div class=\"lsLockAItem lsLockAItem3Display lsLockAItem3Delay\"></div>";

	oDomRef["setAttribute"]("id", "ls-containerlayer-" + this["sId"]);
	UCF_DomUtil["setStyle"](oDomRef, {
		"position": 'absolute',
		"top": '-10000px',
		"overflow": 'hidden',
		"height": '1px',
		"width": '1px',
		"zIndex": iZIndex
	});
	UCF_DomUtil["setClass"](oDomRef, "urBorderBox lsnoprint " + (bBorder ? "urContBdr" : ""));

	if (bLoading || bSemi) {
		//load the text for the loading animation from messagebundle
		sText = this["sLockedMessage"];
		if (sText == null || sText === '') {
			sText = this["oLS"]["sGetText"]("SAPUR_LOADINGANIM");
		}
		sLoadingDiv = "<div id=\"" + this["sId"] + "-text\" class=\"lsContainer--text urTxtStd urTxtColor urBorderBox urContLoading\" >" + bLockAnim + UCF_XSSEncoder["encodeXML"](sText) +
			"</div>";
		sTextLength = sText["length"] + 'em';
	}
	// eslint-disable-next-line no-unsanitized/property
	oDomRef["innerHTML"] = sLoadingDiv;
	if (sTextLength) {
		UCF_DomUtil["setStyle"](oDomRef["firstChild"], {
			"width": sTextLength
		});
	}

	if (bSemi) {
		UCF_DomUtil["setOpacityStyle"](oDomRef["firstChild"], 65);
	}

	oLoadingDomRef = bLoading ? oDomRef["lastChild"] : null;

	//Correction of the loadng animation if RTL
	if (oLoadingDomRef && window["UCF_System"]["bIsRTL"]) {
		var iDivWidth = oLoadingDomRef["offsetWidth"],
			iLeftBgPos = parseInt(UCF_DomUtil["sGetCurrentStyle"](oLoadingDomRef, "backgroundPositionX")),
			iPaddingRight = parseInt(UCF_DomUtil["sGetCurrentStyle"](oLoadingDomRef, "paddingRight"));

		if (!isNaN(iLeftBgPos)) {
			oLoadingDomRef["style"]["backgroundPositionX"] = (iDivWidth - iPaddingRight + iLeftBgPos) + "px";
		} else {
			oLoadingDomRef["style"]["backgroundPositionX"] = (iDivWidth - iPaddingRight + 5) + "px";
		}
	}

	// Ensure valid refernces to dependant objects (see also 1378409 2010)
	return {
		"oDomRef": oDomRef,
		"oSemiDomRef": bSemi ? oDomRef["firstChild"] : null,
		"oLoadingDomRef": oLoadingDomRef
	};

};;if (__UCF_COVERAGE__) { UCF_Container["_"]["oCreateLockLayer"] = 0; };

/**
 * Sets the postion o
 * The object is positioned away from the screen if height or width is 0
 * @param {Element} oDomRef the dom element that
 */
UCF_Container["prototype"]["applyRect"] = function(oDomRef, oRect) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["applyRect"]++; }; 
	if (!oDomRef) return;
	var oStyle = oDomRef["style"];
	if (oRect["height"] === 0 || oRect["width"] === 0) {
		oStyle["top"] = "-10000px";
		oStyle["height"] = "1px";
		oStyle["width"] = "1px";
	} else {
		for (var n in oRect) oStyle[n] = oRect[n] + "px";
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["applyRect"] = 0; };

/**
 * Listener of the any event
 * This listener is only attached if the container is currently locked
 * @private
 */
UCF_Container["prototype"]["onAnyEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onAnyEvent"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oEvent) === "object", "typeof(oEvent) === \"object\"", "Container.js(404): onAnyEvent"); };
	var oBrowserEvent = oEvent["oGetParam"]("oBrowserEvent"),
		sName = oBrowserEvent["sGetName"](),
		oSource = oBrowserEvent["oGetSource"](),
		oFocusTo;

	// skip locked container for non-508, forward tabbing (Tab)
	if (!this["oLS"]["oSystem"]["bIs508"] && this["bLocked"]) {
		if (this["oDomRef"] === oSource && (sName === "focusin" || sName === "focus")) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Skip locked Container forward", "Container.js(413): onAnyEvent"); };

			var oNext;
			oNext = UCF_DomUtil["oGetNextSibling"](this["oDomRef"], true);
			if (oNext) oFocusTo = UCF_DomUtil["oGetTabbableElementForward"](oNext, true);

			if (oFocusTo) {
				UCF_DomUtil["focusDomElement"](oFocusTo);
			} else {
				this["oLS"]["focusEnd"]();
			}
			return;
		}
	}

	// skip locked container for non-508, backward tabbing (Shift-Tab)
	if (!this["oLS"]["oSystem"]["bIs508"] && this["bLocked"]) {
		if (this["oDomRefEnd"] === oSource && (sName === "focusin" || sName === "focus")) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Skip locked Container backward", "Container.js(431): onAnyEvent"); };

			var oPrevious;
			oPrevious = UCF_DomUtil["oGetPreviousSibling"](this["oDomRef"], true);
			if (oPrevious) oFocusTo = UCF_DomUtil["oGetTabbableElementBackward"](oPrevious, true);

			if (oFocusTo) {
				UCF_DomUtil["focusDomElement"](oFocusTo);
			} else {
				this["oLS"]["focusEnd"]();
			}
			return;
		}
	}

	//check whether the event occurred on a source element that is inside my dom element
	if (UCF_DomUtil["bContains"](this["oDomRef"], oSource) && this["oDomRef"] != oSource) {

		//set the locked property on the browser event to avoid handling
		oBrowserEvent["bLocked"] = this["bLocked"];

		//check for native focus events and focus myself
		if (sName === "focusin" || sName === "focus") this["focus"]();
	}

	//for scroll and resize event change the dimension of the blindlayer
	else if (sName === "resize" || sName === "scroll") this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onAnyEvent"] = 0; };

/**
 * Handles the layout change event
 */
UCF_Container["prototype"]["onLayoutChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onLayoutChange"]++; }; 
	this["updateLockedUI"]();
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onLayoutChange"] = 0; };

/*
 * Focus the container if it is locked and it recieves a focus inside.
 */
UCF_Container["prototype"]["focus"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["focus"]++; }; 
	if (this["bLocked"]) {
		UCF_DomUtil["focusDomElement"](this["oDomRef"]);
		//D039230 - set this.oFocusDomRef
		this["oFocusDomRef"] = this["oDomRef"];
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["focus"] = 0; };

/*
 * Focus the next element if tab is pressed if locked
 */
UCF_Container["prototype"]["onlstabnext"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlstabnext"]++; }; 
	if (this["bLocked"]) {
		var focussed = this["focusNextControl"](); //try to focus next sibling and their children
		if (focussed) {
			oBrowserEvent["cancel"]();
			oBrowserEvent["cancelBubble"]();
		} else {
			//No focusable control after the tab strip then leave it up to ls object to find the next element
			this["oLS"]["focusEnd"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlstabnext"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Container["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Container.js(502): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() != this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (this["bLocked"]) {
		// display the message
		oAccessibilityHelper["setText"](this["oLS"]["sGetText"]("SAPUR_CO"));
		var bLoading = this["sLockedDesign"]["indexOf"]("LOADING") > -1;
		if (bLoading) {
			// add the loading message
			var sText = this["sLockedMessage"];
			if (sText == null || sText === "") {
				sText = this["oLS"]["sGetText"]("SAPUR_LOADINGANIM");
			}
			oAccessibilityHelper["addTutor"](sText);
		}
		// TODO: Change the text 'to skip press tab'
		oAccessibilityHelper["addTutor"](this["oLS"]["sGetText"]("SAPUR_CO_TUT"));
	}

	// This gets only called for 508 when tabstop is activated
	// on locked container:

	// TODO: Accessiblity
	//   - introduce a new parameter "AccessiblityDescription"
	//   - consider convenient default text (i.e. "Locked Container"
	// var sText = "Locked Container" + " " + this.sId;
	// oAccessibilityHelper.setText(sText);
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["onlsaccessibility"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Container["prototype"]["aAttributeNames"] = ["bLocked","bPrintable","bPrintArea","sLockedDesign","sLockedMessage","sCustomData","sCustomStyle"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Container["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Container["prototype"]["aMethodNames"] = ["lock","unlock","setLockedDesign","setLockedMessage","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {boolean}
 */
UCF_Container["prototype"]["bLocked"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Container["prototype"]["bPrintable"] = true;

/**
 * @private
 * @type {boolean}
 */
UCF_Container["prototype"]["bPrintArea"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LockedDesign}
 */
UCF_Container["prototype"]["sLockedDesign"] = "TRANSPARENT";

/**
 * @private
 * @type {string}
 */
UCF_Container["prototype"]["sLockedMessage"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Container["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Container["prototype"]["sCustomStyle"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Container["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Container["_"]["setDefaultValues"]++; }; 
	this["bLocked"] = false;
	this["bPrintable"] = true;
	this["bPrintArea"] = false;
	this["sLockedDesign"] = "TRANSPARENT";
	this["sLockedMessage"] = '';
	this["sCustomData"] = '';
	this["sCustomStyle"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Locked", false, true);
		this["setClientProperty"]("Printable", true, true);
		this["setClientProperty"]("PrintArea", false, true);
		this["setClientProperty"]("LockedDesign", "TRANSPARENT", true);
		this["setClientProperty"]("LockedMessage", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("CustomStyle", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Container["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

UCF_Container.prototype["aPublicMethods"] = ["lock","unlock"].concat(UCF_Container.prototype.aPublicMethods || []);
};